module.exports = __webpack_public_path__ + "static/media/KonectaBTO.8b9c63c0.png";